import { useAuth } from '../context/AuthContext';
import { ROLES } from '../config/roles';

export const useAuthorization = (component) => {
    const { user } = useAuth();
    const roles = user?.roles || [];

    const can = (action) => {
        if (!component?.abilities) return false;
        const requiredRoles = component.abilities[action] || [];
        return roles.some(role => requiredRoles.includes(role));
    };

    const isAdmin = roles.includes(ROLES.ADMINS);
    return {
        can: (action) => isAdmin || can(action),
    };
};